// aiAssessment組件翻譯
export default {
  // AI助手文案
  assistant: {
    title: "我是圖鏈智能助手小圖",
    description:
      "我融合了大模型和北鳴科技豐富的研判經驗，輔助您對地址進行研判分析以及解答您關於虛擬幣的任何問題。",
  },

  // 佔位符文本
  placeholder:
    '請輸入一個有效的區塊鏈地址以便幫助您對其進行分析\n您可以嘗試這樣提問，如: "幫我對TWpMnUh9pZS1Mf8yyy9WPiS82WYevKzQo2地址在Tron鏈上主幣的交易數據進行綜合分析"',

  // 工具提示
  tooltips: {
    historicalRecords: "對話記錄",
  },

  // 示例卡片
  examples: {
    example1: "分析Tron上的USDT流出情況，地址是TFP...z7f",
    example2: "對TWpM...Qo2進行綜合分析",
    fullExample1:
      "分析Tron上的USDT流出情況，地址是TFPgHWmveJ8CA4cyKXFq2mik8AbQemuz7f",
    fullExample2: "對TWpMnUh9pZS1Mf8yyw9WPiS82WYevKzQo2進行綜合分析",
  },
};
